import { generateSectionParagraphs } from "../utils/WordExportUtils";
import {
  blueColour,
  defaultFontBold,
  defaultFontNormal,
} from "../utils/styling";

export const getBankChargesParagraphs = () => {
  const paragraphs = [
    {
      segments: [
        {
          text: "Bank Charges:",
          font: defaultFontBold,
          break: 1,
        },
        {
          text: "Under s383(2) TIOPA 2010, the definition of Tax-Interest includes debits brought into account in respect of loan relationships. Matters that are brought into account in respect of loan relationships include expenses incurred by the company for the purposes of its loan relationships and related transactions, which are identified in s306A(2) CTA 2009 as those expenses incurred in bringing loan relationships into existence, in making payments and receiving payments or giving effect to related transactions. As such, many bank charges incurred by a company will constitute Tax-Interest expense amounts, regardless of whether they are included within interest expense or admin expenses.",
          font: defaultFontNormal,
          break: 1,
        },
        {
          text: "[Optional]",
          font: defaultFontNormal,
          color: blueColour,
          break: 2,
        },
        {
          text: " However, certain expenses including credit card charges are arguably not included in directly receiving payments in respect of the loan relationship itself (i.e. payments to and from the bank), but are a cost to ensure the receipt of funds from the customer that are deposited in the company bank account. Whilst not free from doubt, we consider that it is reasonable that these fees can be excluded from Tax-Interest amounts when clearly separable from other bank charges incurred.",
          font: defaultFontNormal,
        },
        {
          text: "[/Optional]",
          font: defaultFontNormal,
          color: blueColour,
        },
      ],
    },
  ];

  return [...generateSectionParagraphs(paragraphs)];
};
